import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { usersApi } from '../services/users.service';

/**
 * Tipo para las aplicaciones obtenidas del método `getApplications`.
 */
interface Application {
    id: string;
    name: string;
}

/**
 * Hook para obtener la lista de aplicaciones.
 *
 * @returns Las aplicaciones y el estado de la consulta.
 */
export const useGetApplications = (): UseQueryResult<Application[], Error> => {
    return useQuery<Application[], Error>({
        queryKey: ['applications'], // Clave única para la consulta
        queryFn: async (): Promise<Application[]> => {
            const applications = await usersApi.getApplications();
            return applications.data;
        },
    });
};
